var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBatchuploadformatSample(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 141.878,
    height: 228.309,
    viewBox: "0 0 141.878 228.309",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ecebea;}.b{fill:#d9d8d7;}.c,.h{fill:none;}.c{stroke:#d4d4d4;stroke-width:0.75px;}.c,.h,.i{stroke-miterlimit:10;}.d{fill:#b7b7b7;}.e,.i{fill:#227346;}.f{fill:#5e5e5e;}.g{fill:#1a1a1a;}.h{stroke:#227346;}.i{stroke:#fff;stroke-width:0.3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.31)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 29.339,
    height: 227.921,
    transform: "translate(0 0.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 141.503,
    height: 21.195,
    transform: "translate(0 0.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 60.79,
    height: 20.854,
    transform: "translate(29.628 0.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 29.103,
    height: 15.739,
    transform: "translate(0 21.675)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    y2: 227.934,
    transform: "translate(90.418 0.31)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    y2: 207.08,
    transform: "translate(29.339 21.164)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 141.503,
    transform: "translate(0 164.634)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 141.503,
    transform: "translate(0 148.725)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 141.503,
    transform: "translate(0 132.829)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 141.503,
    transform: "translate(0 116.92)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 141.503,
    transform: "translate(0 101.024)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 141.503,
    transform: "translate(0 85.115)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 141.503,
    transform: "translate(0 69.219)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 141.503,
    transform: "translate(0 53.323)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 141.503,
    transform: "translate(0 37.414)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 141.503,
    transform: "translate(0 21.518)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 141.503,
    transform: "translate(0 180.53)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 141.503,
    transform: "translate(0 196.439)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 141.503,
    transform: "translate(0 212.335)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x1: 141.503,
    transform: "translate(0 228.244)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    y2: 227.934,
    transform: "translate(141.503 0.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M23.853,17.436H11L23.853,4.57Z",
    transform: "translate(3.427 1.327)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M45.849,4.85h1.81l3.292,9.181H48.983L48.3,12.037H45.141l-.7,2.046H42.57Zm1.876,5.561-1-2.99-.971,2.99Z",
    transform: "translate(13.263 1.414)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M87,4.892h3.41a3.344,3.344,0,0,1,2.387.8,2.125,2.125,0,0,1,.616,1.561h0A2.151,2.151,0,0,1,92.1,9.259a2.19,2.19,0,0,1,1.639,2.19v.144c0,1.653-1.312,2.518-3.305,2.518H87Zm4.472,2.767c0-.669-.459-1.023-1.312-1.023H88.784V8.643H90.1c.839,0,1.312-.341,1.312-1.036Zm-1.023,2.623H88.784v2.151h1.705c.839,0,1.39-.367,1.39-1.075h0c0-.708-.5-1.075-1.43-1.075Z",
    transform: "translate(27.105 1.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M11.7,20.9l-1.312.407-.249-1.154,1.967-.643h1v8.512H11.7Z",
    transform: "translate(3.159 5.982)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M9.46,39l2.623-2.767c.957-1,1.312-1.521,1.312-2.217a1.154,1.154,0,0,0-1.233-1.207c-.669,0-1.141.367-1.705,1.089l-.931-.866a3.213,3.213,0,0,1,2.754-1.521A2.348,2.348,0,0,1,14.824,33.9h0c0,1.154-.525,1.836-1.771,3.082l-1.692,1.836h3.5v1.312H9.46Z",
    transform: "translate(2.947 9.718)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M9.35,51.147l.879-1a2.374,2.374,0,0,0,1.836.892,1.312,1.312,0,0,0,1.39-1.312h0c0-.866-.748-1.312-1.928-1.312h-.433l-.171-.892,2.059-2.466H9.77V43.75H14.74v1.1L12.59,47.317a2.361,2.361,0,0,1,2.256,2.348h0a2.623,2.623,0,0,1-2.78,2.623A3.554,3.554,0,0,1,9.35,51.147Z",
    transform: "translate(2.913 13.534)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M13.028,62.462H9.264L9.08,61.439l4.026-5.679h1.312v5.561h1.049V62.5H14.418v1.836H13.106Zm0-1.18v-3.41l-2.4,3.449Z",
    transform: "translate(2.829 17.275)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M9.39,75.455l.8-1.036a2.623,2.623,0,0,0,1.8.813,1.43,1.43,0,0,0,1.521-1.521h0a1.416,1.416,0,0,0-1.561-1.43,2.859,2.859,0,0,0-1.312.315l-.826-.538.249-4.158h4.485v1.312H11.252l-.131,2.02a3.16,3.16,0,0,1,1.128-.2,2.453,2.453,0,0,1,2.623,2.623h0a2.728,2.728,0,0,1-2.9,2.872A3.725,3.725,0,0,1,9.39,75.455Z",
    transform: "translate(2.925 21.058)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M10.321,87.9a4.3,4.3,0,0,1-.984-3.279v-.092c0-2.859,1.194-4.617,3.292-4.617a3.344,3.344,0,0,1,2.177.774l-.7,1.115a2.361,2.361,0,0,0-1.521-.6c-1.22,0-1.784,1.312-1.81,2.689a2.3,2.3,0,0,1,1.771-.774,2.466,2.466,0,0,1,2.623,2.623h0a2.767,2.767,0,0,1-2.82,2.885A2.7,2.7,0,0,1,10.321,87.9Zm3.423-2.046h0a1.4,1.4,0,0,0-1.469-1.521,1.43,1.43,0,0,0-1.469,1.521h0a1.456,1.456,0,0,0,1.5,1.574,1.43,1.43,0,0,0,1.443-1.587Z",
    transform: "translate(2.9 24.799)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M13.3,93.392H9.6V92.08h5.246v1.062l-3.279,7.45H10.033Z",
    transform: "translate(2.991 28.591)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M9.34,110.413h0a2.138,2.138,0,0,1,1.377-2.072,2.072,2.072,0,0,1-1.141-1.889h0a2.413,2.413,0,0,1,2.623-2.269,2.387,2.387,0,0,1,2.623,2.269h0a2.046,2.046,0,0,1-1.141,1.889,2.138,2.138,0,0,1,1.39,2.046h0a2.623,2.623,0,0,1-2.885,2.426,2.623,2.623,0,0,1-2.846-2.4Zm4.394-.1h0A1.312,1.312,0,0,0,12.226,109a1.377,1.377,0,0,0-1.521,1.312h0a1.312,1.312,0,0,0,1.521,1.312,1.312,1.312,0,0,0,1.508-1.312Zm-.21-3.8h0a1.22,1.22,0,0,0-1.312-1.22A1.22,1.22,0,0,0,10.9,106.5h0a1.312,1.312,0,1,0,2.623,0Z",
    transform: "translate(2.91 32.358)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M13.7,121.032a2.269,2.269,0,0,1-1.771.787A2.479,2.479,0,0,1,9.311,119.2h0a2.78,2.78,0,0,1,2.82-2.925,2.623,2.623,0,0,1,1.994.774,4.354,4.354,0,0,1,.984,3.279v.079c0,2.938-1.246,4.63-3.292,4.63a3.489,3.489,0,0,1-2.3-.852l.7-1.115a2.5,2.5,0,0,0,1.626.682C13.088,123.655,13.665,122.4,13.7,121.032Zm0-1.98h0a1.482,1.482,0,1,0-2.938,0h0a1.447,1.447,0,1,0,2.885,0Z",
    transform: "translate(2.899 36.126)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M8.8,129.816l-1.312.407L7.25,129l1.967-.643H10.2V136.9H8.8Z",
    transform: "translate(2.259 39.894)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M10.71,132.746v-.131c0-2.623,1.312-4.315,3.226-4.315s3.2,1.718,3.2,4.3v.131c0,2.623-1.312,4.328-3.226,4.328S10.71,135.33,10.71,132.746Zm4.984,0v-.092c0-1.889-.734-3.056-1.784-3.056s-1.771,1.141-1.771,3.03v.1c0,1.9.721,3.056,1.8,3.056s1.757-1.154,1.757-3.056Z",
    transform: "translate(3.337 39.875)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M10.091,141.9l-1.312.407-.249-1.154,1.954-.643h1v8.512h-1.39Z",
    transform: "translate(2.658 43.679)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M13.368,141.916l-1.312.407-.236-1.22,1.967-.643h.892v8.578H13.368Z",
    transform: "translate(3.683 43.664)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M9.225,154.016l-1.312.407L7.69,153.2l1.954-.643h1V161.1H9.225Z",
    transform: "translate(2.396 47.433)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M11.08,160l2.623-2.767c.957-1,1.312-1.521,1.312-2.217a1.167,1.167,0,0,0-1.312-1.207c-.669,0-1.141.367-1.692,1.089l-.931-.866a3.174,3.174,0,0,1,2.741-1.521,2.361,2.361,0,0,1,2.623,2.387h0c0,1.154-.538,1.836-1.771,3.082l-1.705,1.836h3.5v1.312H11.08Z",
    transform: "translate(3.452 47.414)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M9.238,166.116l-1.312.407L7.69,165.3l1.967-.643h1V173.2H9.238Z",
    transform: "translate(2.396 51.203)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M11,172.147l.866-1a2.374,2.374,0,0,0,1.836.892,1.312,1.312,0,0,0,1.39-1.312h0c0-.866-.748-1.312-1.928-1.312h-.459l-.184-.892,2.059-2.466H11.367V164.75h4.971v1.1L14.2,168.317a2.361,2.361,0,0,1,2.256,2.348h0a2.623,2.623,0,0,1-2.78,2.623A3.528,3.528,0,0,1,11,172.147Z",
    transform: "translate(3.427 51.231)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M25.07,19.5h1.4v8.525h-1.4Z",
    transform: "translate(7.811 5.979)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M27.6,19.5h2.623a3.935,3.935,0,0,1,4.026,4.184v.1a3.935,3.935,0,0,1-4.053,4.236H27.57ZM29,20.812v5.9h1.18A2.623,2.623,0,0,0,32.8,23.789v-.066a2.623,2.623,0,0,0-2.623-2.951Z",
    transform: "translate(8.589 5.978)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M29.8,33.016l-1.312.407L28.27,32.2l1.967-.643h.984V40.1H29.8Z",
    transform: "translate(8.807 9.736)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M31.66,39l2.623-2.767c.957-1,1.312-1.521,1.312-2.217a1.167,1.167,0,0,0-1.233-1.207c-.669,0-1.141.367-1.705,1.089l-.931-.866a3.187,3.187,0,0,1,2.754-1.521A2.348,2.348,0,0,1,37.024,33.9h0c0,1.154-.538,1.836-1.771,3.082l-1.692,1.836h3.5v1.312H31.686Z",
    transform: "translate(9.864 9.718)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M36.49,39.047l.879-1a2.348,2.348,0,0,0,1.823.892,1.312,1.312,0,0,0,1.39-1.312h0c0-.879-.748-1.312-1.928-1.312h-.42l-.184-.892,2.059-2.466H36.9V31.65h4.971v1.1l-2.085,2.4A2.361,2.361,0,0,1,42.038,37.5h0a2.623,2.623,0,0,1-2.78,2.623,3.528,3.528,0,0,1-2.767-1.075Z",
    transform: "translate(11.368 9.764)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M45.368,38.262H41.617l-.2-1.023,4.04-5.679h1.312v5.522h1.062v1.18H46.771V40.1H45.46Zm0-1.18v-3.41l-2.4,3.41Z",
    transform: "translate(12.904 9.736)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M47,39.158l.8-1.036a2.623,2.623,0,0,0,1.81.813,1.43,1.43,0,0,0,1.456-1.561h0a1.416,1.416,0,0,0-1.561-1.43,2.9,2.9,0,0,0-1.312.315l-.826-.538L47.6,31.59h4.512V32.9H48.81l-.131,2.02a3.161,3.161,0,0,1,1.128-.2,2.466,2.466,0,0,1,2.623,2.623h0a2.728,2.728,0,0,1-2.807,2.885A3.751,3.751,0,0,1,47,39.158Z",
    transform: "translate(14.643 9.745)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M53.061,39.494a4.249,4.249,0,0,1-.984-3.279V36.1c0-2.859,1.18-4.617,3.279-4.617a3.344,3.344,0,0,1,2.177.774l-.7,1.115a2.335,2.335,0,0,0-1.521-.6c-1.22,0-1.771,1.312-1.81,2.689a2.3,2.3,0,0,1,1.784-.774A2.479,2.479,0,0,1,57.914,37.3h0a2.78,2.78,0,0,1-2.833,2.885A2.623,2.623,0,0,1,53.061,39.494Zm3.41-2.085h0a1.469,1.469,0,1,0-2.925,0h0a1.456,1.456,0,0,0,1.482,1.574,1.43,1.43,0,0,0,1.443-1.574Z",
    transform: "translate(16.215 9.711)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M60.969,32.892h-3.7V31.58h5.246v1.062L59.25,40.066H57.716Z",
    transform: "translate(17.842 9.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M62.022,37.816h0a2.138,2.138,0,0,1,1.312-2.072,2.085,2.085,0,0,1-1.141-1.9h0a2.413,2.413,0,0,1,2.623-2.269,2.387,2.387,0,0,1,2.623,2.269h0a2.059,2.059,0,0,1-1.141,1.9,2.151,2.151,0,0,1,1.4,2.046h0a2.925,2.925,0,0,1-5.771,0Zm4.381-.1h0a1.521,1.521,0,0,0-3.017,0h0a1.477,1.477,0,0,0,2.951,0Zm-.2-3.8h0a1.22,1.22,0,0,0-1.312-1.22,1.207,1.207,0,0,0-1.312,1.22h0a1.312,1.312,0,1,0,2.623,0Z",
    transform: "translate(19.294 9.736)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M29.8,45.116l-1.312.407L28.27,44.3l1.967-.643h.984V52.2H29.8Z",
    transform: "translate(8.807 13.506)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M31.66,51.1l2.623-2.767c.957-1,1.312-1.521,1.312-2.217a1.167,1.167,0,0,0-1.233-1.207c-.669,0-1.141.367-1.705,1.089l-.931-.866a3.187,3.187,0,0,1,2.754-1.521A2.348,2.348,0,0,1,37.024,46h0c0,1.154-.538,1.836-1.771,3.082l-1.692,1.836h3.5v1.312H31.686Z",
    transform: "translate(9.864 13.488)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M36.49,51.147l.879-1a2.348,2.348,0,0,0,1.823.892,1.312,1.312,0,0,0,1.39-1.312h0c0-.866-.748-1.312-1.928-1.312h-.42l-.184-.892,2.059-2.466H36.9V43.75h4.971v1.1l-2.085,2.4A2.361,2.361,0,0,1,42.038,49.6h0a2.623,2.623,0,0,1-2.78,2.623,3.528,3.528,0,0,1-2.767-1.075Z",
    transform: "translate(11.368 13.534)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M45.368,50.359H41.617l-.2-1.01,4.04-5.679h1.312v5.522h1.062v1.18H46.771v1.836H45.46Zm0-1.18v-3.41l-2.4,3.41Z",
    transform: "translate(12.904 13.509)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M47,51.261l.8-1.036a2.623,2.623,0,0,0,1.81.813,1.43,1.43,0,0,0,1.508-1.521h0a1.416,1.416,0,0,0-1.613-1.482,2.9,2.9,0,0,0-1.312.315l-.826-.538L47.6,43.68h4.512v1.312H48.81l-.131,2.02a3.161,3.161,0,0,1,1.128-.2,2.466,2.466,0,0,1,2.623,2.623h0a2.728,2.728,0,0,1-2.807,2.9A3.751,3.751,0,0,1,47,51.261Z",
    transform: "translate(14.643 13.512)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M53.061,51.587a4.249,4.249,0,0,1-.984-3.279v-.092c0-2.859,1.18-4.617,3.279-4.617a3.344,3.344,0,0,1,2.177.774l-.7,1.062a2.335,2.335,0,0,0-1.521-.6c-1.22,0-1.771,1.312-1.81,2.689a2.3,2.3,0,0,1,1.784-.774,2.479,2.479,0,0,1,2.623,2.623h0a2.78,2.78,0,0,1-2.833,2.885A2.623,2.623,0,0,1,53.061,51.587Zm3.41-2.046h0a1.469,1.469,0,1,0-2.925,0h0a1.456,1.456,0,0,0,1.482,1.574,1.43,1.43,0,0,0,1.443-1.574Z",
    transform: "translate(16.215 13.487)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M60.969,44.992h-3.7V43.68h5.246v1.062L59.25,52.166H57.716Z",
    transform: "translate(17.842 13.512)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M62.022,49.913h0a2.138,2.138,0,0,1,1.312-2.072,2.072,2.072,0,0,1-1.141-1.889h0a2.413,2.413,0,0,1,2.623-2.269,2.387,2.387,0,0,1,2.623,2.269h0A2.046,2.046,0,0,1,66.3,47.84a2.151,2.151,0,0,1,1.4,2.046h0a2.925,2.925,0,0,1-5.771,0Zm4.381-.1h0a1.521,1.521,0,0,0-3.017,0h0a1.477,1.477,0,0,0,2.951,0Zm-.2-3.8h0a1.22,1.22,0,0,0-1.312-1.22A1.207,1.207,0,0,0,63.583,46h0a1.312,1.312,0,1,0,2.623,0Z",
    transform: "translate(19.294 13.509)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M29.8,57.216l-1.312.407L28.27,56.4l1.967-.643h.984V64.3H29.8Z",
    transform: "translate(8.807 17.275)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M31.66,63.2l2.623-2.767c.957-1,1.312-1.521,1.312-2.217a1.167,1.167,0,0,0-1.233-1.207c-.669,0-1.141.367-1.705,1.089l-.931-.866a3.187,3.187,0,0,1,2.754-1.521A2.348,2.348,0,0,1,37.024,58.1h0c0,1.154-.538,1.836-1.771,3.082l-1.692,1.836h3.5v1.312H31.686Z",
    transform: "translate(9.864 17.258)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M36.49,63.247l.879-1a2.348,2.348,0,0,0,1.823.892,1.312,1.312,0,0,0,1.39-1.312h0c0-.866-.748-1.312-1.928-1.312h-.42l-.184-.892,2.059-2.466H36.9V55.85h4.971v1.1l-2.085,2.4A2.361,2.361,0,0,1,42.038,61.7h0a2.623,2.623,0,0,1-2.78,2.623,3.528,3.528,0,0,1-2.767-1.075Z",
    transform: "translate(11.368 17.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M45.368,62.462H41.617l-.2-1.023,4.04-5.679h1.312v5.561h1.062V62.5H46.771v1.836H45.46Zm0-1.18v-3.41l-2.4,3.449Z",
    transform: "translate(12.904 17.275)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M47,63.339l.8-1.036a2.623,2.623,0,0,0,1.81.813,1.43,1.43,0,0,0,1.508-1.521h0a1.416,1.416,0,0,0-1.561-1.43,2.9,2.9,0,0,0-1.312.315l-.853-.5.236-4.131h4.486v1.312H48.81l-.131,2.02a3.161,3.161,0,0,1,1.128-.2,2.466,2.466,0,0,1,2.623,2.623h0a2.728,2.728,0,0,1-2.807,2.807A3.751,3.751,0,0,1,47,63.339Z",
    transform: "translate(14.643 17.303)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M53.061,63.687a4.249,4.249,0,0,1-.984-3.279v-.092c0-2.859,1.18-4.617,3.279-4.617a3.344,3.344,0,0,1,2.177.774l-.7,1.115a2.335,2.335,0,0,0-1.521-.6c-1.22,0-1.771,1.312-1.81,2.623a2.3,2.3,0,0,1,1.784-.774,2.479,2.479,0,0,1,2.623,2.623h0a2.78,2.78,0,0,1-2.833,2.885A2.623,2.623,0,0,1,53.061,63.687Zm3.41-2.046h0a1.469,1.469,0,1,0-2.925,0h0a1.456,1.456,0,0,0,1.482,1.574,1.43,1.43,0,0,0,1.443-1.574Z",
    transform: "translate(16.215 17.257)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M60.969,57.092h-3.7V55.78h5.246v1.062L59.25,64.266H57.716Z",
    transform: "translate(17.842 17.282)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M62.022,62.013h0a2.138,2.138,0,0,1,1.312-2.072,2.072,2.072,0,0,1-1.141-1.889h0a2.413,2.413,0,0,1,2.623-2.269,2.387,2.387,0,0,1,2.623,2.269h0A2.046,2.046,0,0,1,66.3,59.94a2.151,2.151,0,0,1,1.4,2.046h0a2.925,2.925,0,0,1-5.771,0Zm4.381-.1h0a1.521,1.521,0,0,0-3.017,0h0a1.477,1.477,0,0,0,2.951,0Zm-.2-3.8h0a1.22,1.22,0,0,0-1.312-1.22,1.207,1.207,0,0,0-1.312,1.22h0a1.312,1.312,0,0,0,2.623,0Z",
    transform: "translate(19.294 17.279)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M29.8,69.346l-1.312.407-.223-1.22,1.967-.643h.984v8.538H29.8Z",
    transform: "translate(8.807 21.054)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M31.66,75.292l2.623-2.767c.957-1,1.312-1.521,1.312-2.217A1.167,1.167,0,0,0,34.362,69.1c-.669,0-1.141.367-1.705,1.089l-.957-.826a3.187,3.187,0,0,1,2.754-1.521A2.348,2.348,0,0,1,37,70.229h0c0,1.154-.538,1.836-1.771,3.082l-1.692,1.836h3.5v1.312H31.66Z",
    transform: "translate(9.864 21.037)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M36.49,75.35l.879-1a2.335,2.335,0,0,0,1.823.879,1.312,1.312,0,0,0,1.39-1.312h0c0-.879-.748-1.312-1.928-1.312h-.42l-.184-.892,2.059-2.466H36.9V67.94h4.971v1.1l-2.085,2.413A2.361,2.361,0,0,1,42.038,73.8h0a2.623,2.623,0,0,1-2.78,2.623A3.528,3.528,0,0,1,36.49,75.35Z",
    transform: "translate(11.368 21.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M45.368,74.592H41.617l-.2-1.023,4.04-5.679h1.312v5.522h1.062v1.18H46.771v1.836H45.46Zm0-1.18V70l-2.4,3.41Z",
    transform: "translate(12.904 21.054)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M47,75.448l.8-1.036a2.623,2.623,0,0,0,1.81.813A1.43,1.43,0,0,0,51.118,73.7h0a1.416,1.416,0,0,0-1.561-1.43,2.9,2.9,0,0,0-1.312.315l-.826-.538.236-4.131h4.459v1.312H48.81l-.131,2.02a3.161,3.161,0,0,1,1.128-.2,2.453,2.453,0,0,1,2.623,2.623h0a2.728,2.728,0,0,1-2.807,2.846A3.751,3.751,0,0,1,47,75.448Z",
    transform: "translate(14.643 21.064)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M53.061,75.787a4.249,4.249,0,0,1-.984-3.279v-.092c0-2.859,1.18-4.617,3.279-4.617a3.344,3.344,0,0,1,2.177.774l-.7,1.115a2.335,2.335,0,0,0-1.521-.6c-1.22,0-1.771,1.312-1.81,2.623a2.3,2.3,0,0,1,1.784-.774,2.479,2.479,0,0,1,2.623,2.623h0a2.78,2.78,0,0,1-2.833,2.9A2.623,2.623,0,0,1,53.061,75.787Zm3.41-2.046h0a1.469,1.469,0,1,0-2.925,0h0a1.456,1.456,0,0,0,1.482,1.574,1.43,1.43,0,0,0,1.443-1.574Z",
    transform: "translate(16.215 21.026)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M60.969,69.192h-3.7V67.88h5.246v1.062L59.25,76.366H57.716Z",
    transform: "translate(17.842 21.051)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M62.016,74.131h0a2.138,2.138,0,0,1,1.312-2.138,2.085,2.085,0,0,1-1.141-1.9h0a2.413,2.413,0,0,1,2.623-2.269,2.387,2.387,0,0,1,2.623,2.269h0a2.059,2.059,0,0,1-1.115,1.9,2.151,2.151,0,0,1,1.4,2.046h0a2.925,2.925,0,0,1-5.771,0Zm4.381-.1h0a1.521,1.521,0,0,0-3.017,0h0a1.477,1.477,0,0,0,2.951,0Zm-.2-3.8h0A1.22,1.22,0,0,0,64.888,69a1.207,1.207,0,0,0-1.312,1.22h0a1.312,1.312,0,0,0,2.623,0Z",
    transform: "translate(19.3 21.03)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M29.8,81.416l-1.312.407L28.27,80.6l1.967-.643h.984V88.5H29.8Z",
    transform: "translate(8.807 24.815)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M31.66,87.4l2.623-2.767c.957-1,1.312-1.521,1.312-2.217a1.167,1.167,0,0,0-1.233-1.207c-.669,0-1.141.367-1.705,1.089l-.931-.866a3.187,3.187,0,0,1,2.754-1.521A2.348,2.348,0,0,1,37.024,82.3h0c0,1.154-.538,1.836-1.771,3.082l-1.692,1.836h3.5v1.312H31.686Z",
    transform: "translate(9.864 24.797)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M36.49,87.463l.879-1a2.348,2.348,0,0,0,1.823.892,1.312,1.312,0,0,0,1.39-1.312h0c0-.866-.748-1.312-1.928-1.312h-.42l-.184-.892,2.059-2.531H36.9V80h4.971v1.1l-2.085,2.466a2.361,2.361,0,0,1,2.256,2.348h0a2.623,2.623,0,0,1-2.78,2.623,3.528,3.528,0,0,1-2.767-1.075Z",
    transform: "translate(11.368 24.827)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M45.368,86.65H41.617l-.2-1.023L45.46,80h1.312v5.522h1.062V86.7H46.771v1.836H45.46Zm0-1.18v-3.41l-2.4,3.41Z",
    transform: "translate(12.904 24.827)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M47,87.555l.8-1.036a2.623,2.623,0,0,0,1.81.813,1.43,1.43,0,0,0,1.508-1.521h0a1.416,1.416,0,0,0-1.561-1.43,2.9,2.9,0,0,0-1.312.315l-.826-.538L47.63,80h4.486v1.312H48.81l-.131,2.02a3.161,3.161,0,0,1,1.128-.2,2.466,2.466,0,0,1,2.623,2.623h0a2.728,2.728,0,0,1-2.807,2.872A3.751,3.751,0,0,1,47,87.555Z",
    transform: "translate(14.643 24.827)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M53.061,87.9a4.249,4.249,0,0,1-.984-3.279v-.092c0-2.859,1.18-4.617,3.279-4.617a3.344,3.344,0,0,1,2.177.774l-.7,1.115a2.334,2.334,0,0,0-1.521-.6c-1.22,0-1.771,1.312-1.81,2.689a2.3,2.3,0,0,1,1.784-.774,2.479,2.479,0,0,1,2.623,2.623h0a2.78,2.78,0,0,1-2.833,2.885,2.623,2.623,0,0,1-2.02-.721Zm3.41-2.046h0a1.469,1.469,0,1,0-2.925,0h0a1.456,1.456,0,0,0,1.482,1.574,1.43,1.43,0,0,0,1.443-1.587Z",
    transform: "translate(16.215 24.799)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M60.969,81.312h-3.7V80h5.246v1.062L59.25,88.486H57.716Z",
    transform: "translate(17.842 24.827)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M62.022,86.216h0a2.138,2.138,0,0,1,1.312-2.072,2.085,2.085,0,0,1-1.141-1.9h0a2.413,2.413,0,0,1,2.623-2.269,2.387,2.387,0,0,1,2.623,2.269h0a2.059,2.059,0,0,1-1.141,1.9,2.151,2.151,0,0,1,1.4,2.046h0a2.925,2.925,0,0,1-5.771,0Zm4.381-.1h0a1.521,1.521,0,0,0-3.017,0h0a1.477,1.477,0,0,0,2.951,0Zm-.2-3.8h0a1.22,1.22,0,0,0-1.312-1.22,1.207,1.207,0,0,0-1.312,1.22h0a1.312,1.312,0,0,0,2.623,0Z",
    transform: "translate(19.294 24.815)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M29.8,93.516l-1.312.407L28.27,92.7l1.967-.643h.984V100.6H29.8Z",
    transform: "translate(8.807 28.585)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M31.66,99.5l2.623-2.767c.957-1,1.312-1.521,1.312-2.217a1.167,1.167,0,0,0-1.259-1.207c-.669,0-1.141.367-1.705,1.089l-.931-.866A3.187,3.187,0,0,1,34.454,92,2.348,2.348,0,0,1,37,94.389h0c0,1.154-.538,1.836-1.771,3.082l-1.692,1.836h3.5v1.312H31.66Z",
    transform: "translate(9.864 28.564)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M36.49,99.547l.879-1a2.348,2.348,0,0,0,1.823.892,1.312,1.312,0,0,0,1.39-1.312h0c0-.879-.748-1.312-1.928-1.312h-.42l-.184-.892,2.059-2.466H36.9V92.15h4.971v1.1l-2.085,2.4A2.361,2.361,0,0,1,42.038,98h0a2.623,2.623,0,0,1-2.78,2.623A3.528,3.528,0,0,1,36.49,99.547Z",
    transform: "translate(11.368 28.613)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M45.368,98.762H41.617l-.2-1.023,4.04-5.679h1.312v5.522h1.062v1.18H46.771V100.6H45.46Zm0-1.18v-3.41l-2.4,3.41Z",
    transform: "translate(12.904 28.585)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M47,99.648l.8-1.036a2.623,2.623,0,0,0,1.81.813A1.43,1.43,0,0,0,51.118,97.9h0a1.416,1.416,0,0,0-1.561-1.43,2.9,2.9,0,0,0-1.312.315l-.826-.538.236-4.131h4.459v1.312H48.81l-.131,2.02a3.161,3.161,0,0,1,1.128-.2,2.466,2.466,0,0,1,2.623,2.623h0a2.728,2.728,0,0,1-2.807,2.846A3.751,3.751,0,0,1,47,99.648Z",
    transform: "translate(14.643 28.603)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M53.061,99.987a4.249,4.249,0,0,1-.984-3.279v-.092c0-2.859,1.18-4.617,3.279-4.617a3.344,3.344,0,0,1,2.177.774l-.7,1.115a2.335,2.335,0,0,0-1.521-.577c-1.22,0-1.771,1.312-1.81,2.623a2.3,2.3,0,0,1,1.784-.774,2.479,2.479,0,0,1,2.623,2.623h0a2.78,2.78,0,0,1-2.833,2.885,2.623,2.623,0,0,1-2.02-.682Zm3.41-2.046h0a1.469,1.469,0,1,0-2.925,0h0a1.456,1.456,0,0,0,1.482,1.574,1.43,1.43,0,0,0,1.443-1.574Z",
    transform: "translate(16.215 28.566)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M60.969,93.392h-3.7V92.08h5.246v1.062l-3.266,7.423H57.716Z",
    transform: "translate(17.842 28.591)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M62.022,98.316h0a2.138,2.138,0,0,1,1.312-2.072,2.085,2.085,0,0,1-1.141-1.9h0a2.413,2.413,0,0,1,2.623-2.269,2.387,2.387,0,0,1,2.623,2.269h0a2.059,2.059,0,0,1-1.141,1.9,2.151,2.151,0,0,1,1.4,2.046h0a2.925,2.925,0,0,1-5.771,0Zm4.381-.1h0a1.521,1.521,0,0,0-3.017,0h0a1.477,1.477,0,0,0,2.951,0Zm-.2-3.8h0a1.22,1.22,0,0,0-1.312-1.22,1.207,1.207,0,0,0-1.312,1.22h0a1.312,1.312,0,0,0,2.623,0Z",
    transform: "translate(19.294 28.585)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M29.8,105.616l-1.312.407-.223-1.22,1.967-.643h.984V112.7H29.8Z",
    transform: "translate(8.807 32.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M31.66,111.6l2.623-2.767c.957-1,1.312-1.521,1.312-2.217a1.167,1.167,0,0,0-1.233-1.207c-.669,0-1.141.367-1.705,1.089l-.931-.866a3.187,3.187,0,0,1,2.754-1.521,2.348,2.348,0,0,1,2.544,2.387h0c0,1.154-.538,1.836-1.771,3.082l-1.692,1.836h3.5v1.312H31.686Z",
    transform: "translate(9.864 32.337)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M36.49,111.647l.879-1a2.348,2.348,0,0,0,1.823.892,1.312,1.312,0,0,0,1.39-1.312h0c0-.866-.748-1.312-1.928-1.312h-.42l-.184-.892,2.059-2.466H36.9V104.25h4.971v.984l-2.085,2.518a2.361,2.361,0,0,1,2.256,2.348h0a2.623,2.623,0,0,1-2.78,2.623,3.528,3.528,0,0,1-2.767-1.075Z",
    transform: "translate(11.368 32.382)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M45.368,110.862H41.617l-.2-1.023,4.04-5.679h1.312v5.522h1.062v1.18H46.771V112.7H45.46Zm0-1.18v-3.41l-2.4,3.41Z",
    transform: "translate(12.904 32.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M47,111.788l.8-1.036a2.623,2.623,0,0,0,1.81.813,1.43,1.43,0,0,0,1.508-1.521h0a1.416,1.416,0,0,0-1.561-1.43,2.9,2.9,0,0,0-1.312.315l-.826-.538.236-4.131h4.459v1.312H48.81l-.131,2.02a3.161,3.161,0,0,1,1.128-.2,2.466,2.466,0,0,1,2.623,2.623h0a2.728,2.728,0,0,1-2.807,2.794A3.751,3.751,0,0,1,47,111.788Z",
    transform: "translate(14.643 32.386)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M53.061,112.087a4.249,4.249,0,0,1-.984-3.279v-.092c0-2.859,1.18-4.617,3.279-4.617a3.344,3.344,0,0,1,2.177.774l-.7,1.115a2.335,2.335,0,0,0-1.521-.6c-1.22,0-1.771,1.312-1.81,2.623a2.3,2.3,0,0,1,1.784-.774,2.479,2.479,0,0,1,2.623,2.623h0a2.78,2.78,0,0,1-2.833,2.885A2.623,2.623,0,0,1,53.061,112.087Zm3.41-2.046h0a1.469,1.469,0,1,0-2.925,0h0a1.456,1.456,0,0,0,1.482,1.574,1.43,1.43,0,0,0,1.443-1.574Z",
    transform: "translate(16.215 32.336)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M60.969,105.492h-3.7V104.18h5.246v1.075l-3.266,7.423H57.716Z",
    transform: "translate(17.842 32.361)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M62.022,110.413h0a2.138,2.138,0,0,1,1.312-2.072,2.072,2.072,0,0,1-1.141-1.889h0a2.413,2.413,0,0,1,2.623-2.269,2.387,2.387,0,0,1,2.623,2.269h0A2.046,2.046,0,0,1,66.3,108.34a2.151,2.151,0,0,1,1.4,2.046h0a2.925,2.925,0,0,1-5.771,0Zm4.381-.1h0a1.521,1.521,0,0,0-3.017,0h0a1.477,1.477,0,0,0,2.951,0Zm-.2-3.8h0a1.22,1.22,0,0,0-1.312-1.22,1.207,1.207,0,0,0-1.312,1.22h0a1.312,1.312,0,1,0,2.623,0Z",
    transform: "translate(19.294 32.358)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M24.62,122.48v-.066a2.021,2.021,0,0,1,2.282-2.059,4.42,4.42,0,0,1,1.482.249v-.262a1.22,1.22,0,0,0-1.39-1.312,3.581,3.581,0,0,0-1.548.393l-.38-1.089a4.564,4.564,0,0,1,2.112-.512,2.269,2.269,0,0,1,2.544,2.505v3.935H28.41v-.787a2.046,2.046,0,0,1-1.784.918,1.889,1.889,0,0,1-2.007-1.915Zm3.777-.315v-.643a3.161,3.161,0,0,0-1.194-.236c-.787,0-1.246.407-1.246,1.089h0a.984.984,0,0,0,1.036,1.023,1.312,1.312,0,0,0,1.4-1.233Z",
    transform: "translate(7.67 36.606)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M30.992,123.838v.971H29.68V116.1h1.312v3.358a2.19,2.19,0,0,1,1.876-1.154c1.312,0,2.505,1.075,2.505,3.253v.17c0,2.151-1.207,3.253-2.505,3.253a2.19,2.19,0,0,1-1.876-1.141Zm3.043-2.138v-.1c0-1.312-.656-2.072-1.482-2.072s-1.535.8-1.535,2.059v.118c0,1.312.708,2.059,1.535,2.059S34.034,122.986,34.034,121.7Z",
    transform: "translate(9.247 36.074)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M34.783,121.2v-.118a3.043,3.043,0,0,1,2.912-3.305,2.715,2.715,0,0,1,2.059.879l-.761,1a1.784,1.784,0,0,0-1.312-.643c-.9,0-1.561.866-1.561,2.085h0c0,1.312.656,2.085,1.587,2.085a1.758,1.758,0,0,0,1.312-.656l.748.918a2.715,2.715,0,0,1-2.138.971,2.977,2.977,0,0,1-2.846-3.213Z",
    transform: "translate(10.833 36.598)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M40.628,117.716l-1.312.407-.236-1.22,1.967-.643h1V124.8H40.628Z",
    transform: "translate(12.175 36.124)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M42.48,123.7l2.623-2.767c.957-1,1.312-1.521,1.312-2.217a1.167,1.167,0,0,0-1.233-1.207c-.669,0-1.141.367-1.705,1.089l-.931-.866a3.213,3.213,0,0,1,2.754-1.521,2.348,2.348,0,0,1,2.518,2.348h0c0,1.154-.525,1.836-1.771,3.082l-1.692,1.836h3.5v1.312H42.48Z",
    transform: "translate(13.235 36.107)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M47.31,123.757l.879-1a2.348,2.348,0,0,0,1.823.892,1.312,1.312,0,0,0,1.4-1.312h0c0-.866-.761-1.312-1.928-1.312h-.433l-.184-.892,2.072-2.466H47.73V116.36H52.7v1.1l-2.151,2.361a2.361,2.361,0,0,1,2.256,2.348h0a2.623,2.623,0,0,1-2.78,2.623,3.554,3.554,0,0,1-2.715-1.036Z",
    transform: "translate(14.739 36.155)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M24.62,134.58v-.066a2.021,2.021,0,0,1,2.282-2.059,4.42,4.42,0,0,1,1.482.249v-.262a1.22,1.22,0,0,0-1.39-1.312,3.58,3.58,0,0,0-1.548.393l-.38-1.089a4.407,4.407,0,0,1,2.112-.512,2.269,2.269,0,0,1,2.544,2.505v3.935H28.41v-.787a2.046,2.046,0,0,1-1.784.918,1.889,1.889,0,0,1-2.007-1.915Zm3.777-.315v-.643a3.161,3.161,0,0,0-1.194-.236c-.787,0-1.246.407-1.246,1.089h0a.984.984,0,0,0,1.036,1.023,1.312,1.312,0,0,0,1.4-1.233Z",
    transform: "translate(7.67 40.375)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M30.992,135.978v.971H29.68V128.2h1.312v3.358a2.19,2.19,0,0,1,1.876-1.154c1.312,0,2.505,1.076,2.505,3.253v.171c0,2.151-1.207,3.253-2.505,3.253a2.19,2.19,0,0,1-1.876-1.1Zm3.043-2.177v-.1c0-1.312-.656-2.072-1.482-2.072s-1.535.8-1.535,2.059v.118c0,1.312.708,2.059,1.535,2.059S34.034,135.086,34.034,133.8Z",
    transform: "translate(9.247 39.844)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M34.784,133.3v-.118A3.043,3.043,0,0,1,37.7,129.88a2.715,2.715,0,0,1,2.059.879l-.761,1a1.784,1.784,0,0,0-1.312-.643c-.9,0-1.561.866-1.561,2.085h0c0,1.312.656,2.085,1.587,2.085a1.758,1.758,0,0,0,1.312-.656l.748.918A2.715,2.715,0,0,1,37.7,136.6a2.977,2.977,0,0,1-2.912-3.292Z",
    transform: "translate(10.832 40.367)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M40.628,129.816l-1.312.407L39.08,129l1.967-.643h1V136.9H40.628Z",
    transform: "translate(12.175 39.894)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M42.48,135.781l2.623-2.767c.957-1,1.312-1.521,1.312-2.217a1.167,1.167,0,0,0-1.233-1.207c-.669,0-1.141.367-1.705,1.089l-.931-.866a3.213,3.213,0,0,1,2.754-1.521,2.348,2.348,0,0,1,2.544,2.387h0c0,1.154-.525,1.836-1.771,3.082L44.382,135.6h3.5v1.312H42.506Z",
    transform: "translate(13.235 39.87)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M47.31,135.85l.879-1a2.335,2.335,0,0,0,1.823.879,1.312,1.312,0,0,0,1.4-1.312h0c0-.879-.761-1.312-1.928-1.312h-.433l-.184-.892,2.072-2.466H47.73V128.44H52.7v1.1l-2.151,2.466a2.361,2.361,0,0,1,2.256,2.348h0a2.623,2.623,0,0,1-2.78,2.623,3.554,3.554,0,0,1-2.715-1.128Z",
    transform: "translate(14.739 39.919)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M29.8,141.916l-1.312.407-.223-1.22,1.967-.643h.984v8.578H29.8Z",
    transform: "translate(8.807 43.664)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M31.66,147.9l2.623-2.767c.957-1,1.312-1.521,1.312-2.217a1.167,1.167,0,0,0-1.233-1.207c-.669,0-1.141.367-1.705,1.089l-.931-.866a3.187,3.187,0,0,1,2.754-1.521,2.348,2.348,0,0,1,2.544,2.387h0c0,1.154-.538,1.836-1.771,3.082l-1.718,1.862h3.5v1.312H31.66Z",
    transform: "translate(9.864 43.646)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M36.49,147.947l.879-1a2.348,2.348,0,0,0,1.823.892,1.312,1.312,0,0,0,1.39-1.312h0c0-.866-.748-1.312-1.928-1.312h-.42l-.184-.892,2.059-2.466H36.9V140.55h4.971v1.1l-2.085,2.4a2.361,2.361,0,0,1,2.2,2.335h0a2.623,2.623,0,0,1-2.78,2.623A3.528,3.528,0,0,1,36.49,147.947Z",
    transform: "translate(11.368 43.692)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M45.368,147.162H41.617l-.2-1.023,4.04-5.679h1.312v5.522h1.062v1.18H46.771v1.876H45.46Zm0-1.18v-3.41l-2.4,3.41Z",
    transform: "translate(12.904 43.664)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M47,148.048l.8-1.036a2.623,2.623,0,0,0,1.81.813,1.43,1.43,0,0,0,1.508-1.521h0a1.416,1.416,0,0,0-1.561-1.43,2.9,2.9,0,0,0-1.312.315l-.826-.538.236-4.131h4.459v1.312H48.81l-.131,2.02a3.161,3.161,0,0,1,1.128-.2,2.466,2.466,0,0,1,2.623,2.623h0a2.728,2.728,0,0,1-2.807,2.846A3.751,3.751,0,0,1,47,148.048Z",
    transform: "translate(14.643 43.682)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M53.061,148.387a4.249,4.249,0,0,1-.984-3.279v-.092c0-2.859,1.18-4.617,3.279-4.617a3.344,3.344,0,0,1,2.177.774l-.7,1.115a2.334,2.334,0,0,0-1.521-.6c-1.22,0-1.771,1.312-1.81,2.689a2.3,2.3,0,0,1,1.784-.774,2.479,2.479,0,0,1,2.623,2.623h0a2.78,2.78,0,0,1-2.833,2.885A2.623,2.623,0,0,1,53.061,148.387Zm3.41-2.046h0a1.469,1.469,0,1,0-2.925,0h0a1.456,1.456,0,0,0,1.482,1.574,1.43,1.43,0,0,0,1.443-1.574Z",
    transform: "translate(16.215 43.645)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M60.969,141.792h-3.7V140.48h5.246v1.062l-3.279,7.489H57.716Z",
    transform: "translate(17.842 43.67)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M62.022,146.716h0a2.138,2.138,0,0,1,1.312-2.072,2.085,2.085,0,0,1-1.141-1.9h0a2.413,2.413,0,0,1,2.623-2.269,2.387,2.387,0,0,1,2.623,2.269h0a2.059,2.059,0,0,1-1.141,1.9,2.151,2.151,0,0,1,1.4,2.046h0a2.925,2.925,0,0,1-5.771,0Zm4.381-.1h0a1.521,1.521,0,0,0-3.017,0h0a1.477,1.477,0,0,0,2.951,0Zm-.2-3.8h0a1.22,1.22,0,0,0-1.312-1.22,1.207,1.207,0,0,0-1.312,1.22h0a1.312,1.312,0,1,0,2.623,0Z",
    transform: "translate(19.294 43.664)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M24.62,158.793h0c0-1.377.918-2.059,2.282-2.059a4.419,4.419,0,0,1,1.482.249v-.38a1.22,1.22,0,0,0-1.39-1.312,3.58,3.58,0,0,0-1.548.393l-.38-1.089a4.407,4.407,0,0,1,2.112-.512,2.269,2.269,0,0,1,2.544,2.518v3.935H28.41v-.787a2.046,2.046,0,0,1-1.784.918,1.889,1.889,0,0,1-2.007-1.876Zm3.777-.315v-.643A3.161,3.161,0,0,0,27.2,157.6c-.787,0-1.246.407-1.246,1.089h0a.984.984,0,0,0,1.036,1.023,1.312,1.312,0,0,0,1.4-1.233Z",
    transform: "translate(7.67 47.902)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M30.992,160.177v.971H29.68V152.4h1.312v3.41a2.19,2.19,0,0,1,1.876-1.154c1.312,0,2.505,1.075,2.505,3.253v.171c0,2.151-1.207,3.253-2.505,3.253a2.19,2.19,0,0,1-1.876-1.154ZM34.034,158v-.1c0-1.312-.656-2.072-1.482-2.072s-1.535.8-1.535,2.059V158c0,1.312.708,2.059,1.535,2.059S34.034,159.286,34.034,158Z",
    transform: "translate(9.247 47.384)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M34.783,157.5v-.118a3.043,3.043,0,0,1,2.912-3.305,2.715,2.715,0,0,1,2.059.879l-.761,1a1.784,1.784,0,0,0-1.312-.643c-.9,0-1.561.866-1.561,2.085h0c0,1.246.656,2.085,1.587,2.085a1.757,1.757,0,0,0,1.312-.656l.748.918a2.715,2.715,0,0,1-2.138.971,2.977,2.977,0,0,1-2.846-3.213Z",
    transform: "translate(10.833 47.907)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M40.628,154.016l-1.312.407-.236-1.22,1.967-.643h1V161.1H40.628Z",
    transform: "translate(12.175 47.433)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M42.48,160l2.623-2.767c.957-1,1.312-1.521,1.312-2.217a1.167,1.167,0,0,0-1.233-1.207c-.669,0-1.141.367-1.705,1.089l-.931-.866a3.213,3.213,0,0,1,2.754-1.521,2.348,2.348,0,0,1,2.544,2.387h0c0,1.154-.525,1.836-1.771,3.082l-1.692,1.836h3.5v1.312H42.506Z",
    transform: "translate(13.235 47.416)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M47.31,160.047l.879-1a2.348,2.348,0,0,0,1.823.892,1.312,1.312,0,0,0,1.4-1.312h0c0-.879-.761-1.312-1.928-1.312h-.433l-.184-.892,2.072-2.466H47.73V152.65H52.7v1.1l-2.151,2.466a2.361,2.361,0,0,1,2.256,2.348h0a2.623,2.623,0,0,1-2.78,2.623,3.554,3.554,0,0,1-2.715-1.141Z",
    transform: "translate(14.739 47.461)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 60.935,
    height: 16.25,
    transform: "translate(29.484 21.164)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 3.423,
    height: 3.423,
    transform: "translate(88.556 35.486)"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatchuploadformatSample);
export default __webpack_public_path__ + "static/media/batchuploadformat-sample.ca288025.svg";
export { ForwardRef as ReactComponent };